import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoostYourKnowledgeOverlayComponent } from './boost-your-knowledge-overlay.component';

@NgModule({
  imports: [CommonModule, BoostYourKnowledgeOverlayComponent],
  exports: [BoostYourKnowledgeOverlayComponent],
})
export class BoostYourKnowledgeOverlayModule {}
